/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { CpdsButtonLinkPrimaryStyle, CpdsButtonLinkStyle, IconWrapper, TextWrapper } from './styles/cpds-button-style';
import { getButtonStyle, getChildrens, getLinkStyle } from './helpers';
import { CpdsButtonSize, CpdsButtonType } from './typings';
import { ThemeColorModeProps, themeStyleClass } from '../utils/cpds-utils';
import { checkValue } from 'src/components/common/helper';

export interface CpdsButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, ThemeColorModeProps {
  tag: 'button' | 'a';
  buttonType?: CpdsButtonType;
  buttonSize?: CpdsButtonSize | string | number;
  isDisabled?: boolean;
  isFullWidth?: boolean;
  domRef?: React.Ref<HTMLElement>;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  href?: string;
  children: React.ReactNode;
  exClasses?: string;
  target?: string;
  styleOverrides?: React.CSSProperties;
  checked?: boolean;
}

const CpdsButton: React.FC<CpdsButtonProps> = (props) => {
  const {
    tag,
    buttonType,
    isDisabled,
    domRef,
    href,
    exClasses,
    styleOverrides,
    themeColorMode,
    children,
    themeTypography,
    target,
    ...rest
  } = props;

  const Tag: any = tag === 'a' ? getLinkStyle(buttonType) : getButtonStyle(buttonType);
  // const childrenCount = React.Children.toArray(children).length;
  const childs = getChildrens(children);  

  const className = themeStyleClass('cpds-button', themeTypography, exClasses);

  return (
    <Tag
      className={className}
      ref={domRef}
      onclick={props.onClick}
      styleOverrides={styleOverrides}
      themeColorMode={themeColorMode}
      isIconButton={!childs.buttonText}
      {...rest}
      disabled={isDisabled}
      {...(checkValue(href) ? { href } : {})}
      {...(checkValue(target) ? { target } : {})}
      buttonType = {buttonType}
    >
      {childs.leadingIcon && <IconWrapper>{childs.leadingIcon}</IconWrapper>}
      {childs.buttonText && <TextWrapper className="cta-copy">{childs.buttonText}</TextWrapper>}
      {childs.buttonText && childs.trailingIcon && <IconWrapper>{childs.trailingIcon}</IconWrapper>}
    </Tag>
  );
};

export default CpdsButton;
